import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid,
         TextField, Typography
} from '@mui/material';

import PageTitle from '../ui/PageTitle';

const styleSheet = theme => ({
    root: {
      marginLeft: -210,
      flexGrow: 1,
      padding: 20,
    },
    rootLoggedIn: {
      flexGrow: 1,
      padding: 20,
    },
    flex: {
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },
    paper2: {
      padding: 12,
      textAlign: 'left',
      color: theme.palette.text.secondary,
    },
    textField2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 4,
      width: 190,
    },
    tos: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 4,
      height: 400,
    },
});
  
class PasswordChange extends Component {
  constructor(props) {
    super(props);

    let theEmail = localStorage.getItem("u_email");

    if (theEmail == null)
    {
      const params = new URLSearchParams(this.props.location.search);
      theEmail = params.get('email');
    }

    this.state = {
      email: theEmail,
      pwdchange: false
    }
  }

    changePassword() {
      var self = this;
      if (this.state.email === null)
        return;
      
      // TODO: Check to see if this email exists
      this.props.auth.changePassword(this.state.email, function(err, resp) {
        if (err)
        {
          self.setState({ pwdchange: true });
        }
        else
        {
          self.setState({ pwdchange: true });
        }
      });
    }
  
    render() {
      const { isAuthenticated } = this.props.auth;
      const classes = this.props.classes;

      //
      if (this.state.pwdchange === true)
      {
        if (isAuthenticated())
        {
          return (
            <div className={classes.rootLoggedIn}>
              <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item xs={12}>
                  <PageTitle title="Password change"/>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body" className={classes.flex}>
                    Please check your email for instructions to complete your password change.
                  </Typography>
                </Grid>
              </Grid>
            </div>
          );
        } else {
          return (
            <div className={classes.root}>
              <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item xs={12}>
                  <PageTitle title="Password reset"/>
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body" className={classes.flex}>
                    Please check your email for instructions to complete your password reset.
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                </Grid>
              </Grid>
            </div>
          );
        }
      } else {
        if (isAuthenticated() && this.state.email !== null)
        {
          return (
            <div className={classes.rootLoggedIn}>
              <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item xs={12}>
                  <PageTitle title="Password change"/>
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1" className={classes.flex}>
                    To change your password, click on the change password button.
                    You'll then receive an email to {this.state.email} with a password reset link.
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={12}>
                  <Button 
                    color="primary" variant="contained"
                    onClick={() => {this.changePassword()}}>
                    Change Password
                  </Button>
                </Grid>
              </Grid>
            </div>
          );            
        }
        else
        {
          return (
            <div className={classes.root}>
              <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item xs={12}>
                  <PageTitle title="Password Reset"/>
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body" className={classes.flex}>
                  To reset your password, enter your email address, and click on the reset password button.
                  You'll then receive an email with a password reset link.
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="email"
                    label="email"
                    className={classes.textField2}
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button 
                    color="secondary" variant="contained"
                    onClick={() => {this.changePassword()}}>
                    Reset Password
                  </Button>
                </Grid>
              </Grid>
            </div>
          );            
        }
      }
    }
  }
  
PasswordChange.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(PasswordChange);